export const formStructure = [
  [
    {
      name: 'frota',
      label: 'Frota',
      placeholder: 'Digite para buscar a frota',
      component: 'SearchSelect',
      type: 'search',
      colProps: { md: 3 },
      minSearchLength: 2,
      maxResults: 5,
    },
    {
      name: 'tipoModelo',
      label: 'Tipo Modelo',
      placeholder: 'Descricao do modelo',
      component: 'FormField',
      type: 'text',
      colProps: { md: 3 },
      readOnly: true,
      disabled: true,
    },
    {
      name: 'motorista',
      label: 'Motorista',
      placeholder: 'Digite para buscar o motorista',
      component: 'SearchSelect',
      type: 'search',
      colProps: { md: 3 },
      minSearchLength: 2,
      maxResults: 5,
    },
    {
      name: 'gestor',
      label: 'Gestor',
      placeholder: 'Digite para buscar o gestor',
      component: 'SearchSelect',
      type: 'search',
      colProps: { md: 3 },
      minSearchLength: 2,
      maxResults: 5,
    },
  ],
  [
    {
      name: 'vazioem',
      label: 'Cidade vazio',
      placeholder: 'Digite aonde esta vazio',
      component: 'FormField',
      type: 'text',
      colProps: { md: 6 },
    },
    {
      name: 'uf',
      label: 'UF',
      placeholder: 'Digite a UF',
      component: 'FormField',
      type: 'text',
      colProps: { md: 6 },
    },
  ],
  [
    {
      name: 'diasParados',
      label: 'Dias parados',
      placeholder: 'Dias parados',
      component: 'FormField',
      type: 'number',
      colProps: { md: 3 },
      disabled: true,
    },
    {
      name: 'diasAguardandoDescarga',
      label: 'Dias Aguardando Descarga',
      placeholder: 'Dias aguardando descarga',
      component: 'FormField',
      type: 'number',
      colProps: { md: 3 },
      disabled: true,
    },
    {
      name: 'dataAgendamento',
      label: 'Data Agendamento',
      placeholder: 'Data agendamento',
      component: 'DatePickers',
      type: 'date',
      colProps: { md: 3 },
    },
    {
      name: 'DataDisponibilidade',
      label: 'Data de disponibilidade',
      placeholder: '',
      component: 'DatePickers',
      type: 'date',
      colProps: { md: 3 },
    },
  ],
  [
    {
      name: 'responsavelComercial',
      label: 'Comercial',
      placeholder: 'Digite o comercial responsavel',
      component: 'FormField',
      type: 'text',
      colProps: { md: 6 },
    },
    {
      name: 'destino',
      label: 'Destino',
      placeholder: 'Destino',
      component: 'FormField',
      type: 'text',
      colProps: { md: 6 },
    },
  ],
  [
    {
      name: 'descargaPendente',
      label: 'Desc. Pendente',
      component: 'CheckBox',
      type: 'checkbox',
      colProps: { md: 'auto' },
    },
    {
      name: 'vazio',
      label: 'Vazio',
      component: 'CheckBox',
      type: 'checkbox',
      colProps: { md: 'auto' },
    },
    {
      name: 'negociacao',
      label: 'Negociacao',
      component: 'CheckBox',
      type: 'checkbox',
      colProps: { md: 'auto' },
    },
    {
      name: 'coleta',
      label: 'Coleta',
      component: 'CheckBox',
      type: 'checkbox',
      colProps: { md: 'auto' },
    },
  ],
];

export const formSections = (initialValues) => [
  {
    title: 'Detalhes',
    rows: [0, 1, 2], // Renderiza as linhas 0, 1 e 2 da formStructure
  },
  {
    title: 'RESPONSAVEIS',
    rows: [3], // Renderiza a linha 3
  },
  {
    title: 'Informacoes Gerais',
    rows: [4], // Renderiza a linha 4
  },
];
